import axios from "axios";
import { RunConfigService, ConfigService } from "@nuskin/ns-util";
import { getPartialConfig } from "@nuskin/configuration-sdk";
import { getStack } from "@ns/ns-contentstack-lib";

export default {
  getTopNavigation,
  getNextGenTopNavigation,
  getNextGenAndCsTopNavigation,
  getCsTopNavigation
};

/**
 * Used to retrieve top nav data from service
 * @returns Promise<data>
 */
async function getTopNavigation() {
  const marketConfig = ConfigService.getMarketConfig();
  const runConfig = RunConfigService.getRunConfig();
  const topNavigationUrl =
    `${marketConfig.siteUrl}` +
    `/apps/hello/services/markettopnavigation.` +
    `${runConfig.language}_${runConfig.country}.json"`;
  const topNavData = await axios.request({
    method: "get",
    url: topNavigationUrl,
    responseType: "json"
  });

  return topNavData.data;
}

const buildNavItem = (navItemConfig, baseUrl, country, language) => {
  return {
    title: navItemConfig.properties.name,
    name: navItemConfig.properties.name,
    href: `${baseUrl}${country}/${language}/catalog/${navItemConfig.identifier}`,
    subnav: (navItemConfig.subCategories || []).map((category) =>
      buildNavItem(category, baseUrl, country, language)
    )
  };
};

async function getNextGenTopNavigation() {
  const { language, country } = RunConfigService.getRunConfig();
  const locale = `${language}_${country}`;

  const { Webview_Base_URL, API_Base_URLs, store_id } = (
    await getPartialConfig({
      Equinox_Markets: ["Webview_Base_URL", "API_Base_URLs", "store_id"]
    })
  ).Equinox_Markets;

  let categoriesURL = `${API_Base_URLs.replace(
    /\/$/g,
    ""
  )}/orchestrationservices/storefront/catalogs/categories/top?locale=${locale}&storeId=${store_id}&multilevel=-1&includeParent=false`;
  if (API_Base_URLs.endsWith("/storefront")) {
    categoriesURL = `${API_Base_URLs.replace(
      /\/$/g,
      ""
    )}/catalogs/categories/top?locale=${locale}&storeId=${store_id}&multilevel=-1&includeParent=false`;
  }

  const nextGenCategories = await axios.get(categoriesURL);

  return nextGenCategories.data.category.subCategories.map((config) =>
    buildNavItem(config, Webview_Base_URL, country, language)
  );
}

async function getCsTopNavigation(entryDetails) {
  const { language, country } = RunConfigService.getRunConfig();
  const locale =
    language && country
      ? `${country.toUpperCase()}-${language.toLowerCase()}`
      : "en";
  const stack = getStack();
  let response;
  try {
    response = await stack
      .ContentType(entryDetails.contentType)
      .Query()
      .where("title", entryDetails.title)
      .language(locale)
      .toJSON()
      .find();
  } catch (e) {
    console.log("Error:", e);
    response = [[]];
  }

  const [data] = response;
  const [csCategories] = data;
  const isValid =
    csCategories &&
    csCategories.navbar_component &&
    csCategories.navbar_component.length > 0;

  return isValid ? formatCsData(csCategories) : [];
}

async function getNextGenAndCsTopNavigation() {
  const nextGenNavigation = await getNextGenTopNavigation();

  const entryDetails = {
    contentType: "ns_default_header",
    title: "NS Minimal Header Additional Navigation"
  };

  const csNavigation = await getCsTopNavigation(entryDetails);
  return [...nextGenNavigation, ...csNavigation];
}

function formatCsData(data) {
  return data.navbar_component.map(({ navigation_menu: navigationMenu }) => {
    return {
      title: navigationMenu.menu_title,
      name: navigationMenu.menu_title,
      href: "",
      hideSeeAll: true,
      subnav: navigationMenu.menu_contents
        .map(({ links_with_title: linksWithTitle }) => {
          return (
            linksWithTitle && {
              title: linksWithTitle.links_title,
              name: linksWithTitle.links_title,
              href: linksWithTitle.title_redirect_url.href,
              subnav: linksWithTitle.links.map(({ title, href }) => {
                return {
                  title,
                  name: title,
                  href,
                  subnav: []
                };
              })
            }
          );
        })
        .filter(Boolean)
    };
  });
}
